import UserWithCheckBoxAndPicture from './UserWithCheckBoxAndPicture'
import UserStatus from './UserStatus'


export default {
  user: UserWithCheckBoxAndPicture,
  status: UserStatus,
}
